"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GSO = exports.GSO_PK = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const anchor_1 = require("@project-serum/anchor");
const staking_options_1 = require("@dual-finance/staking-options");
const associated_token_1 = require("@project-serum/associated-token");
const gso_json_1 = __importDefault(require("./gso.json"));
const utils_1 = require("./utils");
const GSO_STATE_SIZE = 1000;
exports.GSO_PK = new web3_js_1.PublicKey('DuALd6fooWzVDkaTsQzDAxPGYCnLrnWamdNNTNxicdX8');
const metaplexId = new web3_js_1.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
/**
 * API class with functions to interact with the Staking Options Program using Solana Web3 JS API
 */
class GSO {
    /**
     * Create a GSO object
     *
     * @param rpcUrl The solana cluster endpoint used for the connecton
     */
    constructor(rpcUrl, commitment = 'finalized') {
        this.commitment = commitment;
        this.connection = new web3_js_1.Connection(rpcUrl, this.commitment || 'finalized');
        const opts = {
            preflightCommitment: 'finalized',
            commitment: 'finalized',
        };
        // Public key and payer not actually needed since this does not send transactions.
        const wallet = {
            publicKey: exports.GSO_PK,
            signAllTransactions: (txs) => __awaiter(this, void 0, void 0, function* () { return txs; }),
            signTransaction: (tx) => __awaiter(this, void 0, void 0, function* () { return tx; }),
            payer: new web3_js_1.Keypair(),
        };
        const provider = new anchor_1.AnchorProvider(this.connection, wallet, opts);
        this.program = new anchor_1.Program(gso_json_1.default, exports.GSO_PK, provider);
    }
    /**
     * Convert a number to bytes in the format that is used in ata seeds.
     */
    static toBeBytes(x) {
        const y = Math.floor(x / Math.pow(2, 32));
        return Uint8Array.from([y, y << 8, y << 16, y << 24, x, x << 8, x << 16, x << 24].map((z) => z >>> 24));
    }
    /**
     * Get the public key for the gso state.
     */
    state(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const [state, _stateBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('GSO-state')),
                GSO.toBeBytes(1),
                Buffer.from(anchor_1.utils.bytes.utf8.encode(name)),
            ], this.program.programId);
            return state;
        });
    }
    /**
     * Get the public key for xBase token.
     */
    xBaseMint(gsoState) {
        return __awaiter(this, void 0, void 0, function* () {
            const [xBaseMint, _xBaseMintBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('xGSO')),
                gsoState.toBuffer(),
            ], this.program.programId);
            return xBaseMint;
        });
    }
    /**
     * Get the public key for base vault.
     */
    baseVault(gsoState) {
        return __awaiter(this, void 0, void 0, function* () {
            const [baseVault, _baseVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('base-vault')),
                gsoState.toBuffer(),
            ], this.program.programId);
            return baseVault;
        });
    }
    /**
     * Create an instruction for config
     */
    createConfigInstruction(lockupRatioPerMillionLots, lockupPeriodEnd, optionExpiration, subscriptionPeriodEnd, numTokensAtoms, projectName, strikeAtomsPerLot, authority, lockupMint, soBaseMint, soQuoteMint, baseAccount, quoteAccount, lotSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const gsoState = yield this.state(projectName);
            const [soAuthority, soAuthorityBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('gso')),
                gsoState.toBuffer(),
            ], this.program.programId);
            const so = new staking_options_1.StakingOptions(this.connection.rpcEndpoint);
            const soState = yield so.state(`GSO${projectName}`, soBaseMint);
            const soBaseVault = yield so.baseVault(`GSO${projectName}`, soBaseMint);
            const soOptionMint = yield so.soMint(strikeAtomsPerLot, `GSO${projectName}`, soBaseMint);
            const xBaseMint = yield this.xBaseMint(gsoState);
            const baseVault = yield this.baseVault(gsoState);
            // TODO: Init fee account if needed.
            return this.program.instruction.configV2(new anchor_1.BN(1), /* period_num */ new anchor_1.BN(lockupRatioPerMillionLots), new anchor_1.BN(lockupPeriodEnd), new anchor_1.BN(optionExpiration), new anchor_1.BN(subscriptionPeriodEnd), new anchor_1.BN(lotSize), numTokensAtoms, projectName, new anchor_1.BN(strikeAtomsPerLot), soAuthorityBump, {
                accounts: {
                    authority,
                    gsoState,
                    soAuthority,
                    soState,
                    soBaseVault,
                    soBaseAccount: baseAccount,
                    soQuoteAccount: quoteAccount,
                    lockupMint,
                    soBaseMint,
                    soQuoteMint,
                    soOptionMint,
                    xBaseMint,
                    baseVault,
                    stakingOptionsProgram: staking_options_1.STAKING_OPTIONS_PK,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                },
            });
        });
    }
    /**
     * Create an instruction for name tokens
     * TODO: Once returning multiple insructions, merge this with config
     */
    createNameTokensInstruction(projectName, strikeAtomsPerLot, authority, baseMint) {
        return __awaiter(this, void 0, void 0, function* () {
            const gsoState = yield this.state(projectName);
            const [soAuthority, _soAuthorityBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('gso')),
                gsoState.toBuffer(),
            ], this.program.programId);
            const so = new staking_options_1.StakingOptions(this.connection.rpcEndpoint);
            const soState = yield so.state(`GSO${projectName}`, baseMint);
            const soOptionMint = yield so.soMint(strikeAtomsPerLot, `GSO${projectName}`, baseMint);
            const xBaseMint = yield this.xBaseMint(gsoState);
            const [optionMetadata, _optionMintMetadataBump] = (yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('metadata')),
                metaplexId.toBuffer(),
                soOptionMint.toBuffer(),
            ], metaplexId));
            const [xBaseMetadata, _xBaseMintMetadataAccountBump] = (yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('metadata')),
                metaplexId.toBuffer(),
                xBaseMint.toBuffer(),
            ], metaplexId));
            return this.program.instruction.nameTokens({
                accounts: {
                    authority,
                    gsoState,
                    xBaseMint,
                    xBaseMetadata,
                    soAuthority,
                    soState,
                    soOptionMint,
                    optionMetadata,
                    stakingOptionsProgram: staking_options_1.STAKING_OPTIONS_PK,
                    tokenMetadataProgram: metaplexId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                },
            });
        });
    }
    /**
     * Create an instruction for stake
     */
    createStakeInstruction(amount, projectName, authority, baseMint, userBaseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const gsoState = yield this.state(projectName);
            const [soAuthority, _soAuthorityBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('gso')),
                gsoState.toBuffer(),
            ], this.program.programId);
            const so = new staking_options_1.StakingOptions(this.connection.rpcEndpoint);
            const soState = yield so.state(`GSO${projectName}`, baseMint);
            const soStateObj = yield so.getState(`GSO${projectName}`, baseMint);
            const strike = soStateObj.strikes[0];
            const soOptionMint = yield so.soMint(strike, `GSO${projectName}`, baseMint);
            const xBaseMint = yield this.xBaseMint(gsoState);
            const baseVault = yield this.baseVault(gsoState);
            // TODO: Possibly init these.
            const soUserOptionAccount = yield (0, associated_token_1.getAssociatedTokenAddress)(authority, soOptionMint);
            const userXBaseAccount = yield (0, associated_token_1.getAssociatedTokenAddress)(authority, xBaseMint);
            return this.program.instruction.stake(new anchor_1.BN(amount), {
                accounts: {
                    authority,
                    gsoState,
                    soAuthority,
                    soOptionMint,
                    soState,
                    xBaseMint,
                    soUserOptionAccount,
                    userBaseAccount,
                    userXBaseAccount,
                    stakingOptionsProgram: staking_options_1.STAKING_OPTIONS_PK,
                    baseVault,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                },
            });
        });
    }
    /**
     * Create an instruction for unstake
     */
    createUnstakeInstruction(amount, projectName, authority, userBaseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const gsoState = yield this.state(projectName);
            const xBaseMint = yield this.xBaseMint(gsoState);
            const baseVault = yield this.baseVault(gsoState);
            const userXBaseAccount = yield (0, associated_token_1.getAssociatedTokenAddress)(authority, xBaseMint);
            return this.program.instruction.unstake(new anchor_1.BN(amount), {
                accounts: {
                    authority,
                    gsoState,
                    xBaseMint,
                    userBaseAccount,
                    userXBaseAccount,
                    baseVault,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                },
            });
        });
    }
    /**
     * Create an instruction for withdraw
     */
    createWithdrawInstruction(projectName, baseMint, authority, userBaseAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const gsoState = yield this.state(projectName);
            const so = new staking_options_1.StakingOptions(this.connection.rpcEndpoint);
            const soBaseVault = yield so.baseVault(`GSO${projectName}`, baseMint);
            const soState = yield so.state(`GSO${projectName}`, baseMint);
            const [soAuthority, _soAuthorityBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from(anchor_1.utils.bytes.utf8.encode('gso')),
                gsoState.toBuffer(),
            ], this.program.programId);
            return this.program.instruction.withdraw({
                accounts: {
                    authority,
                    gsoState,
                    soState,
                    soAuthority,
                    soBaseVault,
                    userBaseAccount,
                    stakingOptionsProgram: staking_options_1.STAKING_OPTIONS_PK,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                },
            });
        });
    }
    /**
     * Fetch all stakable GSOs from program accounts.
     * Returns an array of GSO objects representing the account's
     * metadata like name, strike, expiration and subscription timestamps;
     * and its underlying staking option public key.
     * Testing accounts are excluded from the return value.
     */
    getGsos() {
        return __awaiter(this, void 0, void 0, function* () {
            const { connection } = this;
            const stakingOptions = new staking_options_1.StakingOptions(connection.rpcEndpoint);
            const gsoAccounts = yield connection.getProgramAccounts(exports.GSO_PK, {
                filters: [{ dataSize: GSO_STATE_SIZE }],
            });
            const allGsoParams = [];
            for (const gsoStateAccount of gsoAccounts) {
                const { projectName, stakingOptionsState, subscriptionPeriodEnd, strike, lockupRatioTokensPerMillion, baseMint, authority, lockupPeriodEnd, periodNum, } = (0, utils_1.parseGsoState)(gsoStateAccount.account.data);
                const stakeTimeRemainingMs = subscriptionPeriodEnd * 1000 - Date.now();
                const isTesting = projectName.toLowerCase().includes('trial')
                    || projectName.toLowerCase().includes('test');
                if (stakeTimeRemainingMs <= 0 || isTesting || strike === 0) {
                    continue;
                }
                const { lotSize, quoteMint, optionExpiration, } = (yield stakingOptions.getState(`GSO${projectName}`, baseMint));
                allGsoParams.push({
                    periodNum,
                    subscriptionPeriodEnd,
                    lockupRatioTokensPerMillion,
                    strike,
                    projectName,
                    stakingOptionsState,
                    authority,
                    baseMint,
                    lockupPeriodEnd,
                    lotSize,
                    optionExpiration,
                    quoteMint,
                    gsoStatePk: gsoStateAccount.pubkey,
                });
            }
            return allGsoParams;
        });
    }
}
exports.GSO = GSO;
